export default [
  {
    title: 'Virtual Card',
    customIcon: 'NavArrowSvg',
    children: [
      {
        title: 'Virtual Card',
        route: "custom-virtual-card-list",
        path: "/custom-virtual-card/list",
      },
      {
        title: 'Application Group',
        route: "custom-application-group-list",
        path: "/custom-application-group/list",
      },
    ]
  },
];